import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const CreateBlogIndex = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.CREATE_BLOG}/${ROUTE_KEYS.CREATE_BLOG_BODY}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default CreateBlogIndex;
